// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"e1a6e89e","699":"20e5d339","758":"5747503a"}[chunkId] + ".chunk.css";
};